import { Game } from "../../Game";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Utils } from "../../Utils";
import { SponsorManager, WhyCallAd } from "../../SponsorManager";

export class FinalLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "final-layer");

        const darkLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
        darkLayer.alpha = .65;
        darkLayer.inputEnabled = true;
        darkLayer.events.onInputDown.add(this.onDownBackground, this);
        this.add(darkLayer);

        const scaledContainer = new Phaser.Group(this.game);
        scaledContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledContainer.scale.x = GameVars.scaleX;
        this.add(scaledContainer);

        const scale = 10;

        const acrossText = new Phaser.Text(this.game, -140, 100, " Total across: ", { font: "35px RoundsBlack", fill: "#FFFFFF" });
        acrossText.anchor.set(.5);
        acrossText.alpha = 0;
        acrossText.scale.set(scale);
        acrossText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        scaledContainer.add(acrossText);

        const timeText = new Phaser.Text(this.game, -140, 150, " Time taken: ", { font: "35px RoundsBlack", fill: "#FFFFFF" });
        timeText.anchor.set(.5);
        timeText.alpha = 0;
        timeText.scale.set(scale);
        timeText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        scaledContainer.add(timeText);

        const scoreText = new Phaser.Text(this.game, -140, 250, " FINAL SCORE: ", { font: "35px RoundsBlack", fill: "#FFFFFF" });
        scoreText.anchor.set(.5);
        scoreText.alpha = 0;
        scoreText.scale.set(scale);
        scoreText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        scaledContainer.add(scoreText);

        const acrossResult = new Phaser.Text(this.game, 100, 100, " " + GameVars.savedChicken + " ", { font: "35px RoundsBlack", fill: "#FFFFFF" });
        acrossResult.anchor.set(.5);
        acrossResult.alpha = 0;
        acrossResult.scale.set(scale);
        acrossResult.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        scaledContainer.add(acrossResult);

        let time = Math.round((this.game.time.now - GameVars.time) / 1000);

        const minutes = Math.floor(time / 60);
        const seconds = time - (minutes * 60);

        let textMinutes = "" + minutes;
        let textSeconds = "" + seconds;

        if (minutes < 10) {
            textMinutes = "0" + textMinutes;
        }
        if (seconds < 10) {
            textSeconds = "0" + textSeconds;
        }

        let textTime = textMinutes + ":" + textSeconds;

        const timeResult = new Phaser.Text(this.game, 100, 150, " " + textTime + " ", { font: "35px RoundsBlack", fill: "#FFFFFF" });
        timeResult.anchor.set(.5);
        timeResult.alpha = 0;
        timeResult.scale.set(scale);
        timeResult.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        scaledContainer.add(timeResult);

        const scoreResult = new Phaser.Text(this.game, 100, 250, " " + Utils.formatNumber(GameVars.score) + " ", { font: "35px RoundsBlack", fill: "#FFFFFF" });
        scoreResult.anchor.set(.5);
        scoreResult.alpha = 0;
        scoreResult.scale.set(scale);
        scoreResult.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        scaledContainer.add(scoreResult);

        const restartButton = new Phaser.Button(this.game, 0, 335, "texture_atlas_1", this.onClickRestart, this);
        restartButton.setFrames("btn_restart_on.png", "btn_restart_off.png", "btn_restart_on.png", "btn_restart_off.png");
        restartButton.anchor.set(.5);
        restartButton.alpha = 0;
        scaledContainer.add(restartButton);

        const homeButton = new Phaser.Button(this.game, 0, 400, "texture_atlas_1", this.onClickHome, this);
        homeButton.setFrames("btn_home_on.png", "btn_home_off.png", "btn_home_on.png", "btn_home_off.png");
        homeButton.anchor.set(.5);
        homeButton.alpha = 0;
        scaledContainer.add(homeButton);

        // ACROSS

        this.game.add.tween(acrossText)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 1500);

        this.game.add.tween(acrossText.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 1500)
            .onComplete.add(function (): void {
                AudioManager.playSound("over");
            }, this);

        this.game.add.tween(acrossResult)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 2000);

        this.game.add.tween(acrossResult.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 2000)
            .onComplete.add(function (): void {
                AudioManager.playSound("over");
            }, this);

        // TIME

        this.game.add.tween(timeText)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 2500);

        this.game.add.tween(timeText.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 2500)
            .onComplete.add(function (): void {
                AudioManager.playSound("over");
            }, this);

        this.game.add.tween(timeResult)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 3000);

        this.game.add.tween(timeResult.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 3000)
            .onComplete.add(function (): void {
                AudioManager.playSound("over");
            }, this);

        // SCORE

        this.game.add.tween(scoreText)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 3500);

        this.game.add.tween(scoreText.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 3500)
            .onComplete.add(function (): void {
                AudioManager.playSound("over");
            }, this);

        this.game.add.tween(scoreResult)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 4000);

        this.game.add.tween(scoreResult.scale)
            .to({ x: 1, y: 1 }, 250, Phaser.Easing.Linear.None, true, 4000)
            .onComplete.add(function (): void {
                AudioManager.playSound("over");
            }, this);

        // BUTTONS

        this.game.add.tween(restartButton)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 4500);

        this.game.add.tween(homeButton)
            .to({ alpha: 1 }, 250, Phaser.Easing.Linear.None, true, 4500);

        this.alpha = 0;

        this.game.add.tween(this)
            .to({ alpha: 1 }, 500, Phaser.Easing.Linear.None, true, 500);
    }

    private onClickRestart(): void {

        if (typeof prerollStart === "undefined") {

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
                console.log("skip ad, prerollStart not found");
            }

            SponsorManager.adFilter(() => {
                GameManager.enterRoadScene();
            }, Game.currentInstance, WhyCallAd.onClickRetry);

        } else {

            this.game.paused = true;

            LaggedAPI.APIAds.show("interstitial", "lgo-chicken-go", "go-chicken-go-game.png", function (response: any) {
                if (response.success) {
                    console.log("ad done");
                    Game.currentInstance.paused = false;
                    GameManager.enterRoadScene();
                } else {
                    console.log("ad error, continue");
                    Game.currentInstance.paused = false;
                    GameManager.enterRoadScene();
                }
            });
        }

        AudioManager.playSound("click");
    }

    private onClickHome(): void {

        if (typeof prerollStart === "undefined") {

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
                console.log("skip ad, prerollStart not found");
            }

            SponsorManager.adFilter(() => {
                GameManager.enterSplashScene();
            }, Game.currentInstance, WhyCallAd.onClickHome);

        } else {

            this.game.paused = true;

            LaggedAPI.APIAds.show("interstitial", "go-chicken-go", "go-chicken-go-game.png", function (response: any) {
                if (response.success) {
                    console.log("ad done");
                    Game.currentInstance.paused = false;
                    GameManager.enterSplashScene();
                } else {
                    console.log("ad error, continue");
                    Game.currentInstance.paused = false;
                    GameManager.enterSplashScene();
                }
            });
        }

        AudioManager.playSound("click");
    }

    private onDownBackground(): void {
        //
    }
}
